// ประตูหน้าแอป — ไม่มี credential ก็ไปหน้า login ก่อน
//
// ทุกหน้าในแอปนี้อ่านข้อมูลจากระบบปลายทาง (Inbox Center / KOL / Biddable)
// ด้วย token ของผู้ใช้เอง ไม่มี token ก็ไม่มีอะไรให้ดู — พาไป login ตรง ๆ
// ดีกว่าปล่อยให้เดินดูหน้าเปล่า ๆ แล้วค่อยเจอข้อความ "ยังไม่ได้เข้าสู่ระบบ" ทีละกล่อง
import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router";
import { useAppSelector } from "@/app/hooks";

export function RequireSession({ children }: { children: ReactNode }) {
  const session = useAppSelector((s) => s.session.current);
  const location = useLocation();

  if (!session) {
    // จำหน้าที่ตั้งใจจะเข้าไว้ใน ?next= เพื่อพากลับมาหลัง login
    const next = location.pathname + location.search;
    return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />;
  }
  return <>{children}</>;
}
